import log from 'loglevel';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/all';

import jqueryPlugins from './behavior/jquery-plugins';
import windowHorizontalResizeEvent from './behavior/window-horizontal-resize-event';

import { load as loadPageData } from './components/page-data';
import accordions from './components/accordions';
import colorSwatches from './components/color-swatches';
import copyButtons from './components/copy-buttons';
import pageHeader from './components/page-header';
import photoCollectionsNavigators from './components/photo-collections-navigators';
import sidebar from './components/sidebar';
import smoothScrollingAnchors from './components/smooth-scrolling-anchors';
import tabs from './components/tabs';

log.setDefaultLevel('debug');

gsap.config({ nullTargetWarn: false });

gsap.registerPlugin(ScrollToPlugin)

jqueryPlugins.register();
windowHorizontalResizeEvent.register();

const initializeComponents = () => {
    sidebar.initialize();
    pageHeader.initialize();
    accordions.initialize();
    colorSwatches.initialize();
    copyButtons.initialize();
    tabs.initialize();
    photoCollectionsNavigators.initialize();
    smoothScrollingAnchors.initialize();
};

$(function() {
    loadPageData();
    initializeComponents();
});
